export default {"src":"/_next/static/media/timeline-icon.b3565a41.svg","height":21,"width":39,"blurWidth":0,"blurHeight":0};